import {
  InputBaseComponentProps,
  InputBaseProps,
  SxProps,
  TextField,
} from '@mui/material';
import React from 'react';
import { dusk, midnightDarker } from 'src/constants/colors';

type Props = {
  customSx?: SxProps;
  disabled?: boolean;
  inputSx?: React.CSSProperties;
  label: string;
  onChange?: (
    e: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => void;
  value: string;
  placeholder?: string;
  InputProps?: InputBaseProps;
  inputAttrProps?: InputBaseComponentProps;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  autoComplete?: string;
  type?: string;
  autoFocus?: boolean;
};

export const InputField: React.FC<Props> = ({
  customSx,
  disabled,
  inputSx,
  label,
  onChange,
  value,
  placeholder,
  InputProps,
  inputAttrProps,
  onBlur,
  onKeyDown,
  autoComplete = 'on',
  type,
  autoFocus = false,
}) => {
  return (
    <TextField
      onBlur={onBlur}
      disabled={disabled}
      onKeyDown={onKeyDown}
      autoComplete={autoComplete}
      fullWidth
      type={type}
      autoFocus={autoFocus}
      label={label}
      margin="dense"
      onChange={onChange && onChange}
      placeholder={placeholder}
      InputLabelProps={{
        sx: {
          color: dusk,
          fontFamily: 'Rota',
          '&.MuiInputLabel-shrink': {
            fontSize: '18px',
            paddingLeft: 0,
          },
          ...inputSx,
        },
      }}
      inputProps={inputAttrProps}
      InputProps={InputProps}
      sx={{
        backgroundColor: midnightDarker,
        ...customSx,
      }}
      value={value}
    />
  );
};
